<template>
    <table class="table table-hover">
        <thead>
        <tr>
            <th>ID</th>
            <th>{{ $t('common.time.date') }}</th>
            <th v-if="showUser">{{ $t('common.client') }}</th>
            <th>{{ $t('common.service') }}</th>
            <th>{{ $t('common.channel') }}</th>
            <th>{{ $t('common.state') }}</th>
            <th>{{ $t('common.user') }}</th>
            <th>{{ $t('common.payment') }}</th>
        </tr>
        </thead>
        <tbody id="reservation-list">
        <ReservationRow
                :reservation="reservation"
                v-for="reservation in reservations"
                v-bind:key="reservation.id"
                :show-user="showUser"
        ></ReservationRow>
        </tbody>
    </table>
</template>

<script>
    import ReservationRow from "./ReservationRow";

    export default {
        name: "ReservationTable",
        components: { ReservationRow },
        props: {
            reservations: {
                type: Array,
                required: true
            },
            showUser: {
                type: Boolean,
                default: true
            }
        }
    };
</script>
